import {
  Injectable, NgZone
} from '@angular/core';

import {
  UserContext
} from '../user-context';

import {
  NavigationEnd,
  Router, RouterEvent
} from '@angular/router';

import {AuthService} from '../auth';
import {webSocket, WebSocketSubject} from 'rxjs/webSocket';
import {BehaviorSubject, Observable, Subscription, timer} from 'rxjs';
import {ApiService} from './api.service';
import * as marshaller from '@aws-sdk/eventstream-marshaller';
import * as util_utf8_node from '@aws-sdk/util-utf8-node';
import * as mic from 'microphone-stream';
export interface AuthorizeMessage {
  authorize: string
}

interface IWindow extends Window {
  webkitSpeechRecognition: any;
  webkitSpeechGrammarList: any;
  SpeechRecognition: any;
  SpeechGrammarList: any;
}

@Injectable()
export class TranscriptionService extends BehaviorSubject<string> {
  speechRecognition: any;
  private eventStreamMarshaller = new marshaller.EventStreamMarshaller(util_utf8_node.toUtf8, util_utf8_node.fromUtf8);

// our global variables for managing state
  private sampleRate = 44100;
  private inputSampleRate;
  private transcription = "";
  private micStream;
  private socketError = false;
  private transcribeException = false;
  public transcriptionSocket: WebSocketSubject<any>;
  private transcriptionSubscription: Subscription;
  private url:string;

  constructor(
    private api: ApiService,
    private zone: NgZone,
              private auth: AuthService,
              private userContext: UserContext,
              private router: Router) {

    super('');

    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationEnd) {

        //console.log("Navigating to " + event.urlAfterRedirects);
        if( !event.urlAfterRedirects.includes("telehealth") && !event.urlAfterRedirects.includes("live") ) {
          this.stopRecording();
          /*
          this.micStream.stop();

          // Send an empty frame so that Transcribe initiates a closure of the WebSocket after submitting all transcripts

          let emptyMessage = this.getAudioEventMessage(Buffer.from(new Buffer([])));
          let emptyBuffer = this.eventStreamMarshaller.marshall(emptyMessage);
          this.transcriptionSocket.next(emptyBuffer);

          this.transcriptionSocket.unsubscribe();

           */
        }
      }
    });
  }

  startRecording() {
    this.record().subscribe(result => {
      console.log("Received " + result);
      this.next(result);
    }, (err) => {
      if (err.error == "no-speech") {
        this.startRecording();
      }
    },
      () => {
      this.startRecording();
      })
  }

  record(): Observable<string> {

    console.log("Starting recording...");
    return Observable.create(observer => {
      const { webkitSpeechRecognition, webkitSpeechGrammarList }: IWindow = <IWindow>window;
      this.speechRecognition = new webkitSpeechRecognition();
      //this.speechRecognition = SpeechRecognition;
      let speechRecognitionList = new webkitSpeechGrammarList();
      let grammar = '#JSGF V1.0; grammar operations; public <operation> = "close collection" | "open shopping cart" | "open collection *" | "send shopping cart" ;';
      speechRecognitionList.addFromString(grammar, 2);
      this.speechRecognition.continuous = true;
      //this.speechRecognition.interimResults = true;
      this.speechRecognition.lang = 'en-us';
      this.speechRecognition.maxAlternatives = 1;
      this.speechRecognition.grammars = speechRecognitionList;

      this.speechRecognition.onresult = speech => {
        let term: string = "";
        if (speech.results) {
          let result = speech.results[speech.resultIndex];
          let transcript = result[0].transcript;
          if (result.isFinal) {
            if (result[0].confidence < 0.3) {
            }
            else {
              term = transcript;
            }
          }
        }
        this.zone.run(() => {
          observer.next(term);
        });
      };

      this.speechRecognition.onerror = error => {
        observer.error(error);
      };

      this.speechRecognition.onend = () => {
        observer.complete();
      };

      this.speechRecognition.start();
    });
  }

  stopRecording() {
    if (this.speechRecognition)
      this.speechRecognition.stop();
  }

  /*
  public connect(): void {
    this.api.get<any>(`/transcribe`).subscribe(result => {
      this.url = result.url;
      console.log("Got url");

      this.transcriptionSocket = webSocket({
          url: this.url,
          binaryType: "arraybuffer",
          closeObserver: {
            next(closeEvent) {
              console.log("Transcription socket closed");
              this.micStream.stop();
            }
          },
          openObserver: {
            next: (openEvent) => {
              console.log("Transcription socket opened: " + JSON.stringify(openEvent, null,4));

              window.navigator.mediaDevices.getUserMedia({
                video: false,
                audio: true
              }).then(this.streamAudioToWebSocket).catch( (error) => {
                console.log("Error streaming: " + error);
              });
            }
          },
        }
      );

      this.transcriptionSubscription = this.transcriptionSocket.subscribe(
        msg => {
          let messageWrapper = this.eventStreamMarshaller.unmarshall(new Buffer(msg.data));
          let messageBody = JSON.parse(String.fromCharCode.apply(String, messageWrapper.body));
          if (messageWrapper.headers[":message-type"].value === "event") {
            this.handleEventStreamMessage(messageBody);
          } else {
            console.log("Error: " + messageBody.Message);
          }
        },
        err => console.log("web socket error: " + err),
        () => {
          console.log('web socket closed');
        }
      );
    });
  }

  streamAudioToWebSocket(userMediaStream) {
    //let's get the mic input from the browser, via the microphone-stream module
    this.micStream = new mic();

    this.micStream.on("format", (data) => {
      this.inputSampleRate = data.sampleRate;
    });

    this.micStream.setStream(userMediaStream);

    let sampleRate = 0;

    this.micStream.on('data', (rawAudioChunk) => {
      let binary = this.convertAudioToBinaryMessage(rawAudioChunk);
      this.transcriptionSocket.next(binary);
    });
  }


  pcmEncode(input) {
    let offset = 0;
    let buffer = new ArrayBuffer(input.length * 2);
    let view = new DataView(buffer);
    for (let i = 0; i < input.length; i++, offset += 2) {
      let s = Math.max(-1, Math.min(1, input[i]));
      view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
    }
    return buffer;
  }

  downsampleBuffer(buffer, inputSampleRate = 44100, outputSampleRate = 16000) {

    if (outputSampleRate === inputSampleRate) {
      return buffer;
    }

    let sampleRateRatio = inputSampleRate / outputSampleRate;
    let newLength = Math.round(buffer.length / sampleRateRatio);
    let result = new Float32Array(newLength);
    let offsetResult = 0;
    let offsetBuffer = 0;

    while (offsetResult < result.length) {

      let nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);

      let accum = 0,
        count = 0;

      for (let i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++ ) {
        accum += buffer[i];
        count++;
      }

      result[offsetResult] = accum / count;
      offsetResult++;
      offsetBuffer = nextOffsetBuffer;

    }

    return result;

  }

  handleEventStreamMessage(messageJson) {
    let results = messageJson.Transcript.Results;

    if (results.length > 0) {
      if (results[0].Alternatives.length > 0) {
        let transcript = results[0].Alternatives[0].Transcript;

        // fix encoding for accented characters
        transcript = decodeURIComponent(escape(transcript));
        console.log("Received transcript: " + transcript);
        this.next(transcript);
      }
    }
  }

  convertAudioToBinaryMessage(audioChunk) {
    let raw = mic.toRaw(audioChunk);

    if (raw == null)
      return;

    // downsample and convert the raw audio bytes to PCM
    let downsampledBuffer = this.downsampleBuffer(raw, this.inputSampleRate, this.sampleRate);
    let pcmEncodedBuffer = this.pcmEncode(downsampledBuffer);

    // add the right JSON headers and structure to the message
    let audioEventMessage = this.getAudioEventMessage(Buffer.from(pcmEncodedBuffer));

    //convert the JSON object + headers into a binary event stream message
    let binary = this.eventStreamMarshaller.marshall(audioEventMessage);

    return binary;
  }

  getAudioEventMessage(buffer):marshaller.Message {
    // wrap the audio data in a JSON envelope
    return {
      headers: {
        ':message-type': {
          type: 'string',
          value: 'event'
        },
        ':event-type': {
          type: 'string',
          value: 'AudioEvent'
        }
      },
      body: buffer
    };
  }*/
}
